import { useAuth } from '../../contexts/AuthContext';
import styles from './Header.module.css';

export function Header() {
  const { wllUser, isAdmin, signOut, isAuthenticated } = useAuth();

  const displayName = wllUser
    ? `${wllUser.firstName} ${wllUser.lastName}`
    : 'Loading…';

  const initials = wllUser
    ? `${wllUser.firstName[0]}${wllUser.lastName[0]}`.toUpperCase()
    : '?';

  return (
    <header className={styles.header} role="banner">
      <div className={styles.brand}>
        <div className={styles.logo} aria-hidden="true">
          <WllLogo />
        </div>
        <div className={styles.brandText}>
          <span className={styles.brandName}>Well Living Lab</span>
          <span className={styles.brandTagline}>AI Assistant</span>
        </div>
      </div>

      {isAuthenticated && (
        <div className={styles.userArea}>
          {isAdmin && (
            <span className={styles.adminBadge} title="Administrator">
              Admin
            </span>
          )}
          <div className={styles.userInfo} aria-label={`Signed in as ${displayName}`}>
            <div className={styles.avatar} aria-hidden="true">
              {initials}
            </div>
            <span className={styles.userName}>{displayName}</span>
          </div>
          <button
            className={styles.signOutBtn}
            onClick={signOut}
            aria-label="Sign out"
            title="Sign out"
          >
            <SignOutIcon />
            <span>Sign out</span>
          </button>
        </div>
      )}
    </header>
  );
}

function WllLogo() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="#00AEBD" />
      <path
        d="M8 10h3l3 8 3-8h2l3 8 3-8h3l-4.5 12h-2.5l-2.5-7-2.5 7h-2.5L8 10z"
        fill="white"
      />
    </svg>
  );
}

function SignOutIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  );
}
